import { feature, featureCollection } from '@turf/helpers';
import { union } from '@turf/union';
import L from 'leaflet';

import type { MultiPolygon, Polygon } from 'geojson';

const defaultOptions: L.PolylineOptions = {
    fillColor: 'var(--cc-map-mask-area)',
    fillOpacity: 'var(--cc-map-mask-area-opacity)' as unknown as number,
    stroke: false,
    interactive: false,
    className: 'mask-area',
};

export const maskArea = function (geoJsons: Array<Polygon | MultiPolygon>, options?: L.PolylineOptions): L.Polygon {
    if (!geoJsons || geoJsons.length === 0) {
        return;
    }

    // Create a union of all polygons
    const polygon = geoJsons.length > 1 ? union(featureCollection(geoJsons.map((geoJson) => feature(geoJson)))) : feature(geoJsons[0]);
    const latLngs = L.GeoJSON.coordsToLatLngs(polygon.geometry.coordinates, polygon.geometry.type === 'Polygon' ? 1 : 2).map((latLngArray) =>
        polygon.geometry.type === 'Polygon' ? latLngArray.reverse() : latLngArray[0].reverse(),
    );
    return L.polygon(
        [
            [
                [20, -30],
                [20, 50],
                [75, 50],
                [75, -30],
            ],
            ...latLngs,
        ],
        { ...defaultOptions, ...options },
    );
};
